export enum PercentUnit {
  Day = 'day',
  Year = 'year',
}
